import { deserialize } from 'libs/cerialize';

export class LanguageModel {
	@deserialize
	FlagBase64: number;

	@deserialize
	ShortName: string;
}